import { render } from "./SkillDetail.vue?vue&type=template&id=88655504&scoped=true"
import script from "./SkillDetail.vue?vue&type=script&lang=js"
export * from "./SkillDetail.vue?vue&type=script&lang=js"

import "./SkillDetail.vue?vue&type=style&index=0&id=88655504&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-88655504"

export default script